import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "src/components/ui/Card";
import { Button } from "src/components/ui/Button";
import { Pencil, X } from "lucide-react";
import { Modal } from "src/components/ui/Modal";
import { StudentExtendedProfileData } from "src/pages/student/Profile";

interface PhotosSectionProps {
  profileData: StudentExtendedProfileData;
  activeSectionEdit: string | null;
  setActiveSectionEdit: (section: string | null) => void;
  handleOpenPhotoUpload: (type: 'profile' | 'gallery') => void;
}

const PhotosSection: React.FC<PhotosSectionProps> = ({
  profileData,
  activeSectionEdit,
  setActiveSectionEdit,
  handleOpenPhotoUpload
}) => {
  return (
    <>
      {/* Photos & Video Section */}
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>Photos & Video</CardTitle>
          <button
            onClick={() => setActiveSectionEdit('photos')}
            className="p-1 rounded-full hover:bg-gray-100 transition-colors"
            aria-label="Edit Photos & Video"
          >
            <Pencil className="h-4 w-4 text-gray-500" />
          </button>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-4">
            <div className="aspect-square bg-gray-100 rounded-md relative group cursor-pointer" onClick={() => handleOpenPhotoUpload('gallery')}>
              <div className="absolute inset-0 flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400">
                  <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"></path>
                  <circle cx="12" cy="13" r="3"></circle>
                </svg>
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">

              </div>
            </div>
            <div className="aspect-square bg-gray-100 rounded-md relative group cursor-pointer" onClick={() => handleOpenPhotoUpload('gallery')}>
              <div className="absolute inset-0 flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400">
                  <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"></path>
                  <circle cx="12" cy="13" r="3"></circle>
                </svg>
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Photos Edit Modal */}
      {activeSectionEdit === 'photos' && (
        <Modal
          isOpen={activeSectionEdit === 'photos'}
          onClose={() => setActiveSectionEdit(null)}
          title="Manage Photos"
        >
          <div className="grid grid-cols-2 gap-4">
            <div className="aspect-square bg-gray-100 rounded-md relative group cursor-pointer flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400">
                <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"></path>
                <circle cx="12" cy="13" r="3"></circle>
              </svg>
              <div className="absolute top-2 right-2">
                <Button variant="destructive" size="icon" className="h-6 w-6 rounded-full">
                  <X className="h-3 w-3" />
                </Button>
              </div>
            </div>
            <div className="aspect-square bg-gray-100 rounded-md relative group cursor-pointer flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400">
                <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"></path>
                <circle cx="12" cy="13" r="3"></circle>
              </svg>
              <div className="absolute top-2 right-2">
                <Button variant="destructive" size="icon" className="h-6 w-6 rounded-full">
                  <X className="h-3 w-3" />
                </Button>
              </div>
            </div>
          </div>
          <Button className="w-full mt-4" onClick={() => handleOpenPhotoUpload('gallery')}>
            Select New Photo
          </Button>
          <div className="flex flex-row w-full gap-2 mt-6 justify-between">
            <Button variant="outline" onClick={() => setActiveSectionEdit(null)} className="w-32">
              Cancel
            </Button>
            <Button onClick={() => setActiveSectionEdit(null)} className="w-32">
              OK
            </Button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default PhotosSection;
